module.exports = {
          srcSet: __webpack_public_path__ + "5c218fec.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "5c218fec.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "5c218fec.jpg",
          toString:function(){return __webpack_public_path__ + "5c218fec.jpg"},
          
          width: 330,
          height: 200
        }